import {
  Box,
  Divider,
  Icon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AdminRoutes, AgentRoute } from "../../routes";
import AppLogo from "../../assets/images/Trust-telecom-New-Logo.png";
import { AppContext } from "./../../lib/Context";
import DashboardIcon from "@mui/icons-material/Dashboard";

const CustomDrawer = ({ handleDrawerToggle }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { palette } = useTheme();
  const { userData, sendType, handleResetData } = useContext(AppContext);

  // const AllRoutes =
  //   userData?.designation === "Admin" ? AdminRoutes : AgentRoute;

  const getRoutesByRole = () => {
    const isAdmin = userData?._id === process.env.REACT_APP_ADMIN_ID;

    let RenderAdminRoutes = isAdmin
      ? AdminRoutes
      : AdminRoutes.filter((route) => route.name !== "Admin" && route.name !== "Service Agrement");

    if (userData?.designation === "Admin") return RenderAdminRoutes;
    if (userData?.designation === "Sales Agent") return AgentRoute;
    return null;
  };

  const AllRoutes = getRoutesByRole();

  return (
    <Box onClick={handleDrawerToggle}>
      <Box
        p={2}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        width={{ xs: 130, sm: 150 }}
        sx={{ cursor: "pointer" }}
        onClick={() => navigate("/")}
      >
        <img src={AppLogo} width={"100%"} height={"100%"} />
      </Box>

      <Divider />

      <List>
        {AllRoutes?.map((val, ind) => {
          const isMatched = pathname == val.path;
          return (
            <ListItem
              key={ind}
              divider
              sx={{
                cursor: "pointer",
                backgroundColor: isMatched ? "#45c3ff26" : "inherit",
              }}
              onClick={() => {
                if (val.path === "/add-lead" && sendType.type === "edit") {
                  handleResetData(true);
                }

                navigate(`${val.path}`);
              }}
            >
              <ListItemIcon sx={{ minWidth: "40px" }}>
                <Icon sx={{ color: isMatched ? "text.darkBlue" : "inherit" }}>
                  {val.icon}
                </Icon>
              </ListItemIcon>
              <ListItemText
                primary={val.name}
                sx={{
                  "& .MuiListItemText-primary ": {
                    whiteSpace: "nowrap",
                    fontWeight: isMatched ? 500 : 400,
                    color: isMatched ? "text.darkBlue" : "text.coolGrey",
                  },
                }}
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default CustomDrawer;
